import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FCanvasComponent, FCreateConnectionEvent, FZoomDirective } from '@foblex/flow';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { NodeManager } from '@app/utilities/foblex-flow/node-manager';
import { ConnectionManager } from '@app/utilities/foblex-flow/connection-manager';
import { FoblexNode } from '@app/utilities/foblex-flow/base-node/base-node';
import { FlowNodeInteractor } from './nodes.service';
import { DeviceNode } from './device-node/device-node.component';
import { PSDChartNode } from './chart-node/chart-node.component';

@Component({
    selector: 'nodes',
    templateUrl: './nodes.component.html',
    styleUrls: ['./nodes.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,

})
export class NodesComponent implements OnInit {
    public readonly FoblexNode = FoblexNode;
    public readonly DeviceNode = DeviceNode;
    public readonly PSDChartNode = PSDChartNode;

    @ViewChild(FCanvasComponent, { static: false })
    public fCanvas!: FCanvasComponent;

    @ViewChild(FZoomDirective, { static: false })
    public fZoom!: FZoomDirective;

    public deviceNodes: DeviceNode[] = [];
    public psdChartNodes: PSDChartNode[] = [];
    public readonly connections$ = this.connectionManager.connections$;

    constructor(
        private readonly fragQuery: FragQueryService,
        private connectionManager: ConnectionManager,
        public nodeManager: NodeManager,
        public readonly flowNodeInteractor: FlowNodeInteractor,
        private cd: ChangeDetectorRef
    ) { }

    public ngOnInit() {
        this.connectionManager.loadInitialConnections();
        this.flowNodeInteractor.initializeNodes();

        this.nodeManager.nodes$.subscribe(nodes => {
            this.deviceNodes = [];
            this.psdChartNodes = [];
            nodes.forEach(node => {
                if (DeviceNode.isDeviceNode(node)) {
                    this.deviceNodes.push(node);
                } else if (PSDChartNode.isPSDChartNode(node)) {
                    this.psdChartNodes.push(Object.assign(
                        Object.create(Object.getPrototypeOf(node)),
                        node
                    ));
                }
            });
            this.cd.markForCheck();
        });
    }

    public zoomIn() {
        this.fZoom.zoomIn();
    }

    public zoomOut() {
        this.fZoom.zoomOut();
    }

    public resetZoom() {
        this.fZoom.reset();
    }

    public onNodeChanged(nodeId: number, newPosition: { x: number, y: number }) {
        this.nodeManager.updateNodePosition(nodeId, newPosition);
        this.fragQuery.cacheNodePosition(nodeId, newPosition)
    }

    public async onCreateConnection(event: FCreateConnectionEvent) {
        if (!event.fInputId) return;

        await this.connectionManager.addConnectionOnConnect(event.fOutputId, event.fInputId);
        this.fragQuery.trigger$.next()
    }
}
